// extracted by mini-css-extract-plugin
export default {"container":"CompetitivenessPriceIndicator_container__6A12q"};